var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "feriehus-item",
      class: "imp_" + _vm.lodging.postMeta.esName.toLowerCase(),
      attrs: {
        itemprop: "itemListElement",
        itemscope: "",
        itemtype: "https://schema.org/LodgingBusiness",
        id: _vm.translatedId,
        "data-daysold": _vm.lodging.postMeta.daysSince,
        "data-post-id": _vm.lodging.post_ID,
        "data-lodging-id": _vm.lodging.postMeta.esLodgingId,
        "data-lat": _vm.lodging.postMeta.esLatitude,
        "data-lng": _vm.lodging.postMeta.esLongitude,
      },
    },
    [
      _c("meta", {
        attrs: { itemprop: "name", content: _vm.lodging.postMeta.esName },
      }),
      _vm._v(" "),
      _c("meta", { attrs: { itemprop: "telephone", content: "97 31 55 40" } }),
      _vm._v(" "),
      _vm.displayLastMinuteHeader
        ? _c("last-minute-header", { attrs: { lodging: _vm.lodging } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "feriehus-inner-item" },
        [
          _c("title-display", {
            staticClass: "visible-xs mobile-title",
            attrs: { lodging: _vm.lodging, displaySchema: true },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col first" },
            [
              typeof _vm.lodging.images !== "undefined" &&
              _vm.lodging.images.length > 0
                ? [
                    _c("div", {
                      staticClass:
                        "mobile-slider-navigation mobile-slider-next",
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "mobile-slider-navigation mobile-slider-previous",
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "img-wrap",
                  attrs: { "data-url": _vm.parsedUrl },
                },
                [
                  typeof _vm.lodging.images !== "undefined" &&
                  _vm.lodging.images.length > 0
                    ? _vm._l(_vm.lodging.images, function (image, index) {
                        return _c(
                          "a",
                          {
                            staticClass: "lodging-image",
                            class: {
                              primary: index === 0,
                              modelfoto: image.tags === "modelfoto",
                              renoveres: image.tags === "renoveres",
                              de: _vm.isGerman,
                            },
                            attrs: { "data-index": index, href: _vm.parsedUrl },
                          },
                          [
                            _c("img", {
                              staticClass: "img-responsive",
                              class: { primary: index === 0 },
                              attrs: {
                                itemprop: "image",
                                src: _vm.handleImage(
                                  _vm.scaledImagePaths[index]
                                ),
                                alt: image.alt,
                              },
                            }),
                          ]
                        )
                      })
                    : [
                        _c("a", { attrs: { href: _vm.parsedUrl } }, [
                          _c("img", {
                            staticClass:
                              "primary img-responsive tempPlaceHolderImageInItem",
                            attrs: {
                              itemprop: "image",
                              src: _vm.noImagePath,
                              alt: _vm.translations.sentences.imagePending,
                            },
                          }),
                        ]),
                      ],
                  _vm._v(" "),
                  _vm.isLastMinute === true
                    ? _c("div", { staticClass: "last-minute-period" }, [
                        _c("div", { staticClass: "last-minute-inner" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.arrivalFormatted) +
                              " " +
                              _vm._s(_vm.translations.terms.to) +
                              " " +
                              _vm._s(_vm.departureFormatted) +
                              " (" +
                              _vm._s(_vm.durationFormatted) +
                              ")\n\t\t\t\t\t"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                ],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col scnd" },
            [
              _c("title-display", {
                staticClass: "hidden-xs",
                attrs: { lodging: _vm.lodging },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "basic-data" }, [
                _c("div", { staticClass: "row" }, [
                  _c("span", { staticClass: "type" }, [
                    _vm._v(
                      _vm._s(_vm.translations.searchFilterNames[156]) + ":"
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "value",
                      attrs: { itemprop: "maximumAttendeeCapacity" },
                    },
                    [_vm._v(_vm._s(_vm.lodging.facilities[156]))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("span", { staticClass: "type" }, [
                    _vm._v(
                      _vm._s(_vm.translations.searchFilterNames.husdyr) + ":"
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "value",
                      attrs: {
                        itemprop: "petsAllowed",
                        content: "https://schema.org/True",
                      },
                    },
                    [_vm._v(_vm._s(_vm.petsDisplay))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row",
                    attrs: {
                      itemprop: "amenityFeature",
                      itemscope: "",
                      itemtype:
                        "https://schema.org/LocationFeatureSpecification",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "type", attrs: { itemprop: "unitText" } },
                      [
                        _vm._v(
                          _vm._s(_vm.translations.searchFilterNames[179]) + ":"
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "value" }, [
                      _c("span", { attrs: { itemprop: "value" } }, [
                        _vm._v(_vm._s(_vm.lodging.facilities[179])),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { attrs: { itemprop: "unitCode", content: "MTR" } },
                        [_vm._v("m")]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("span", { staticClass: "type" }, [
                    _vm._v(_vm._s(_vm.translations.terms.area) + ":"),
                  ]),
                  _c(
                    "span",
                    { staticClass: "value", attrs: { itemprop: "areaServed" } },
                    [_vm._v(_vm._s(_vm.lodging.postMeta.esAddress2))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("span", { staticClass: "type" }, [
                    _vm._v(
                      _vm._s(_vm.translations.searchFilterNames.skiftedag) + ":"
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "value",
                      attrs: {
                        itemprop: "checkinTime",
                        content: _vm.changedayShorthands,
                      },
                    },
                    [_vm._v(_vm._s(_vm.changedayDisplay))]
                  ),
                ]),
                _vm._v(" "),
                _vm.freeCleaningEnabled
                  ? _c("div", { staticClass: "row yellow" }, [
                      _c("span", { staticClass: "type" }, [
                        _vm._v(
                          _vm._s(_vm.translations.terms.endCleaning) + ":"
                        ),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.translations.terms.FREE)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col text-right third" },
            [
              _c("star-display", {
                attrs: { stars: _vm.lodging.facilities[207] },
              }),
              _vm._v(" "),
              _c("favorite-heart", {
                attrs: { postId: Number(_vm.lodging.post_ID) },
              }),
              _vm._v(" "),
              _c("price-display", { attrs: { lodging: _vm.lodging } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }